module.exports = {"id":"179475","name":"Oleksandr Rybka","rating":"72","photo":"./data/images/photos/4/179475.png","club":{"name":"Karabükspor","logo":"./data/images/clubs/Karabukspor.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OleksandrRybka0.json
// module id = 3264
// module chunks = 0